import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { Theme, Typography, styled } from '@material-ui/core';

import apiRoutes from '../../../../config/api/routes';
import { ExerciseSeries } from '../../../../config/api/models/Exercise';
import { useFetch } from '../../../shared/hooks';
import { BackButton, Paragraph } from '../../../shared/components';
import { TrajectoryViewMode } from '../../../../config/api/models/Trajectory';

type Props = {
  seriesId: string;
  returnPath: string;
  mode: TrajectoryViewMode;
};

const StyledSeriesHeading = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const StyledSeriesTitle = styled(Typography)<Theme>(({ theme }) => ({
  position: 'relative',
  fontWeight: 400,
  paddingRight: theme.spacing(3),
}));

const SeriesDetailHeading: FC<Props> = ({ seriesId, returnPath, mode }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [getSeriesDetailResponse, getSeriesDetail] = useFetch<ExerciseSeries>(
    apiRoutes.pageDetail(seriesId)
  );
  useEffect(() => {
    getSeriesDetail();
  }, [getSeriesDetail]);

  return getSeriesDetailResponse.success ? (
    <>
      <StyledSeriesHeading>
        <BackButton onClick={() => history.push(returnPath)} />
        <StyledSeriesTitle variant="h3">{getSeriesDetailResponse.data.title}</StyledSeriesTitle>
      </StyledSeriesHeading>
      {getSeriesDetailResponse.data.blocks.length === 0 && (
        <Paragraph>
          {mode === 'read'
            ? t('trajectory.sections.shared.emptySeriesIntroView')
            : t('trajectory.sections.shared.emptySeriesIntroEdit')}
        </Paragraph>
      )}
    </>
  ) : null;
};

export default SeriesDetailHeading;
